import { Menu } from "antd";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const HorizontalNav = () => {
  const [activeLink, setActiveLink] = useState("orders");
  const location = useLocation();
  const currentLocation = location.pathname.split("/");
  const handleLinkClick = (key) => {
    setActiveLink(key);
  };
  useEffect(() => {
    setActiveLink(currentLocation[currentLocation.length - 1]);
  }, [currentLocation]);

  return (
    // <div className="pt-2 px-2">
    <Menu
      mode="horizontal"
      className="w-100% lg:w-28 h-5.4 m-0 rounded-sm bg-inputFieldGrey justify-between flex  items-center"
    >
      {/* <div className="flex items-center space-x-2 mr-1 ml-2"> */}
      <div className="flex">
        <Menu.Item
          key="orders"
          className={`mr-1 rounded-sm hover:bg-white ${activeLink === "orders"
            ? "!bg-white !text-black"
            : "!text-grey !bg-inputFieldGrey"
            } `}
          onClick={() => handleLinkClick("orders")}
        >
          <Link to="/main/orders">Orders</Link>
        </Menu.Item>
      </div>
      <div className="flex">
        <Menu.Item
          key="history"
          className={`mr-1 rounded-sm hover:bg-white ${activeLink === "history"
            ? "!bg-white !text-black"
            : "!text-grey !bg-inputFieldGrey"
            } `}
          onClick={() => handleLinkClick("history")}
        >
          <Link to="/main/orders/history">Orders History</Link>
        </Menu.Item>
      </div>
      {/* <div className="flex">
        <Menu.Item
          key="receipt"
          className={`mr-1 rounded-sm hover:bg-white ${
            activeLink === "receipt"
              ? "!bg-white !text-black"
              : "!text-grey !bg-inputFieldGrey"
          } `}
          onClick={() => handleLinkClick("receipt")}
        >
          <Link to="/main/orders/receipt">Receipts</Link>
        </Menu.Item>
      </div> */}
      {/* <div className="flex">
        <Menu.Item
          key="appointments"
          className={`mr-1 rounded-sm hover:bg-white ${
            activeLink === "appointments"
              ? "!bg-white !text-black"
              : "!text-grey !bg-inputFieldGrey"
          } `}
          onClick={() => handleLinkClick("appointments")}
        >
          <Link to="/main/orders/appointments">Appointments</Link>
        </Menu.Item>
      </div> */}
      {/* <div className="flex">
        <Menu.Item
          key="appointment-settings"
          className={`mr-1 rounded-sm hover:bg-white ${
            activeLink === "appointment-settings"
              ? "!bg-white !text-black"
              : "!text-grey !bg-inputFieldGrey"
          } `}
          onClick={() => handleLinkClick("appointment-settings")}
        >
          <Link to="/main/orders/appointment-settings">
            Appointment Settings
          </Link>
        </Menu.Item>
      </div> */}
    </Menu>
    // </div>
  );
};

export default HorizontalNav;
